import React from 'react';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { loadData } from '../Util/List/CustomList/loadData';
import { useSelector } from 'react-redux';
import { usePositionsExportPortal } from './Export/usePositionsExportPortal';

const PositionsPlan = () => {
    const sessionSelector = useSelector((state) => { return state.core.session; });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallpositions',
        endpointGetAllForExport: config.endpoints.backend + 'portal/getallpositionsforexport',
        endpointGetAllSectors: config.endpoints.backend + 'portal/getallpositionssectors',
        endpointGetAllEducationLevels: config.endpoints.backend + 'portal/getallpositionseducationlevels',
        endpointGetAllRoleClasses: config.endpoints.backend + 'portal/getallpositionsroleclasses'
    };

    const { modal: exportModal, openModal: openExportModal } = usePositionsExportPortal({
        endpoint: paths.endpointGetAllForExport,
        baseFilter: { friendly_url }
    });

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'role_name',
                type: 'text',
                label: 'Nome',
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'pdc_cbo_role_class_id',
                type: 'select',
                label: 'Classe',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllRoleClasses,
                    label: 'name',
                    value: 'id',
                    params: { filter: { friendly_url } }
                },
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'pdc_cbo_sector_id',
                type: 'select',
                label: 'Setor',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllSectors,
                    label: 'name',
                    value: 'id',
                    params: { filter: { friendly_url } }
                },
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'pdc_cbo_education_level_id',
                type: 'select',
                label: 'Escolaridade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEducationLevels,
                    label: 'name',
                    value: 'id',
                    params: { filter: { friendly_url } }
                },
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    const list = {
        labelTitle: 'Plano de Cargos e Salários',
        icon: 'fa-id-badge',
        filter: { friendly_url },
        formFilters: filters,
        columns: [
            {
                name: 'role_name',
                label: 'Nome do Cargo'
            },
            {
                name: 'cbo',
                label: 'CBO'
            },
            {
                name: 'role_class_name',
                label: 'Classe'
            },
            {
                name: 'role_classification_code',
                label: 'Classificação'
            },
            {
                name: 'sector_name',
                label: 'Setor'
            }
        ]
    };

    return (
        <div style={{ marginLeft: '35px' }}>
            <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                <a onClick={openExportModal} className="btn btn-primary" style={{ cursor: 'pointer' }}>
                    <i className="fas fa-file-pdf mr-1"></i> Gerar Fichas (PDF)
                </a>
            </div>
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                icon={list.icon}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
            {exportModal}
        </div>
    );
};

export default PositionsPlan;
